import { Route, Routes } from "react-router-dom";

import "./components/styles/App.scss";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import AboutItem from "./components/pages/AboutItem";
import CurrentFocus from "./components/pages/CurrentFocus";
import Footer from "./components/nav/Footer";
import Resume from "./components/pages/Resume";
import NotFound from "./components/pages/NotFound";

export default function App() {
  return (
    <div className="app-container">
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/current-focus" element={<CurrentFocus />} />
        <Route path="/about/:slug" element={<AboutItem />} />
        <Route path="/about" element={<About />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}
